<template>
  <div class="card-form">
    <page-main />
  </div>
</template>

<script>
export default {
  name: "personal-dashBoard",
  components: {
    PageMain: () => import("./components/main"),
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
